
export default {
    data() {
        return {
            COUNTRY_ADDRESS_POSTALS: [{
                abbrev: 'AF',
                name: 'Afghanistan',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'AL',
                name: 'Albania',
                postal: [v => /(120|122)[0-9]{2}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'DZ',
                name: 'Algeria',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'AS',
                name: 'American Samoa',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'AD',
                name: 'Andorra',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'AO',
                name: 'Angola',
            }, {
                abbrev: 'AI',
                name: 'Anguilla',
                postal: [v => /AI-2640$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'AG',
                name: 'Antigua and Barbuda',
            }, {
                abbrev: 'AR',
                name: 'Argentina',
                postal: [v => /[A-Z]{1}[0-9]{4}[A-Z]{3}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'AM',
                name: 'Armenia',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'AW',
                name: 'Aruba',
            }, {
                abbrev: 'AU',
                name: 'Australia',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'AT',
                name: 'Austria',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'AZ',
                name: 'Azerbaijan',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'BS',
                name: 'Bahamas',
            }, {
                abbrev: 'BH',
                name: 'Bahrain',
            }, {
                abbrev: 'BD',
                name: 'Bangladesh',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'BB',
                name: 'Barbados',
                postal: [v => /BB[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'BY',
                name: 'Belarus',
                postal: [v => /[0-9]{6}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'BE',
                name: 'Belgium',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'BZ',
                name: 'Belize',
            }, {
                abbrev: 'BJ',
                name: 'Benin',
            }, {
                abbrev: 'BM',
                name: 'Bermuda',
                postal: [v => /[A-Z]{2}[0-9]{2}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'BT',
                name: 'Bhutan',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'BO',
                name: 'Bolivia',
            }, {
                abbrev: 'BQ',
                name: 'Bonaire',
            }, {
                abbrev: 'BA',
                name: 'Bosnia and Herzegovina',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'BW',
                name: 'Botswana',
            }, {
                abbrev: 'BR',
                name: 'Brazil',
                postal: [v => /[0-9]{5}-[0-9]{3}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'BN',
                name: 'Brunei',
                postal: [v => /[A-Z]{2}[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'BG',
                name: 'Bulgaria',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'BF',
                name: 'Burkina Faso',
            }, {
                abbrev: 'BI',
                name: 'Burundi',
            }, {
                abbrev: 'KH',
                name: 'Cambodia',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'CM',
                name: 'Cameroon',
            }, {
                abbrev: 'CA',
                name: 'Canada',
                postal: [v => /[A-Z][0-9][A-Z] ?[0-9][A-Z][0-9]$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'CI',
                name: 'Canary Islands',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'CV',
                name: 'Cape Verde',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'KY',
                name: 'Cayman Islands',
                postal: [v => /[A-Z]{2}[0-9]-[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'CF',
                name: 'Central African Republic',
            }, {
                abbrev: 'TD',
                name: 'Chad',
            }, {
                abbrev: 'CI',
                name: 'Channel Islands',
                postal: [v => /[A-Z]{2}[0-9]{2}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'CL',
                name: 'Chile',
                postal: [v => /[0-9]{7}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'CN',
                name: "China, People's Republic",
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'CO',
                name: 'Colombia',
                postal: [v => /[0-9]{6}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'KM',
                name: 'Comoros',
            }, {
                abbrev: 'CG',
                name: 'Congo',
            }, {
                abbrev: 'CD',
                name: 'Congo, The Democratic Republic of',
            }, {
                abbrev: 'CK',
                name: 'Cook Islands',
            }, {
                abbrev: 'CR',
                name: 'Costa Rica',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'CI',
                name: "Côte d'Ivoire",
            }, {
                abbrev: 'HR',
                name: 'Croatia',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'CU',
                name: 'Cuba',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'CW',
                name: 'Curacao',
            }, {
                abbrev: 'CY',
                name: 'Cyprus',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'CZ',
                name: 'Czech Republic',
                postal: [v => /[0-9]{3} [0-9]{2}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'DK',
                name: 'Denmark',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'DJ',
                name: 'Djibouti',
            }, {
                abbrev: 'DM',
                name: 'Dominica',
            }, {
                abbrev: 'DO',
                name: 'Dominican Republic',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'TL',
                name: 'East Timor',
            }, {
                abbrev: 'EC',
                name: 'Ecuador',
                postal: [v => /[0-9]{6}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'EG',
                name: 'Egypt',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'SV',
                name: 'El Salvador',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'ER',
                name: 'Eritrea',
            }, {
                abbrev: 'EE',
                name: 'Estonia',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'ET',
                name: 'Ethiopia',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'FK',
                name: 'Falkland Islands',
                postal: [v => /FIQQ 1ZZ$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'FO',
                name: 'Faroe Islands',
                postal: [v => /[0-9]{3}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'FJ',
                name: 'Fiji',
            }, {
                abbrev: 'FI',
                name: 'Finland',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'FR',
                name: 'France',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'PF',
                name: 'French Polynesia',
                postal: [v => /987[0-9]{2}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
                range: ['98700', '98790'],
            }, {
                abbrev: 'GA',
                name: 'Gabon',
            }, {
                abbrev: 'GM',
                name: 'Gambia',
            }, {
                abbrev: 'GE',
                name: 'Georgia',
            }, {
                abbrev: 'DE',
                name: 'Germany',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'GH',
                name: 'Ghana',
            }, {
                abbrev: 'GI',
                name: 'Gibraltar',
                postal: [v => /GX11 1AA$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'GR',
                name: 'Greece',
                postal: [v => /[0-9]{3} [0-9]{2}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'GL',
                name: 'Greenland',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'GD',
                name: 'Grenada',
            }, {
                abbrev: 'GP',
                name: 'Guadeloupe',
                postal: [v => /971[0-9]{2}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
                range: ['97100', '97190'],
            }, {
                abbrev: 'GU',
                name: 'Guam',
                // US postal code
                // https://stackoverflow.com/questions/2577236/regex-for-zip-code
                postal: [v => /^\d{5}(?:[-\s]\d{4})?$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
                range: ['96910', '96932'],
            }, {
                abbrev: 'GT',
                name: 'Guatemala',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'GG',
                name: 'Guernsey',
                // UK postal code
                // https://stackoverflow.com/questions/164979/regex-for-matching-uk-postcodes
                postal: [v => /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'GW',
                name: 'Guinea-Bissau',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],

            }, {
                abbrev: 'GQ',
                name: 'Guinea-Equatorial',
            }, {
                abbrev: 'GN',
                name: 'Guinea Republic',
                postal: [v => /[0-9]{3}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'GY',
                name: 'Guyana (British)',
            }, {
                abbrev: 'GF',
                name: 'Guyana (French)',
                postal: [v => /973[0-9]{2}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
                range: ['97300', '97390'],
            }, {
                abbrev: 'HT',
                name: 'Haiti',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'HN',
                name: 'Honduras',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'HK',
                name: 'Hong Kong',
            }, {
                abbrev: 'HU',
                name: 'Hungary',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'IS',
                name: 'Iceland',
                postal: [v => /[0-9]{3}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'IN',
                name: 'India',
                // https://stackoverflow.com/questions/33865525/indian-pincode-validation-regex-only-six-digits-shouldnt-start-with-0
                postal: [v => /^[1-9][0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'ID',
                name: 'Indonesia',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'IR',
                name: 'Iran',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'IQ',
                name: 'Iraq',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'IE',
                name: 'Ireland, Republic of',
                // https://stackoverflow.com/questions/33391412/validation-for-irish-eircode
                postal: [v => /(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'FK',
                name: 'Islas Malvinas',
                postal: [v => /FIQQ 1ZZ$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'IL',
                name: 'Israel',
                postal: [v => /[0-9]{5}|[0-9]{7}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'IT',
                name: 'Italy',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'CI',
                name: 'Ivory Coast',
            }, {
                abbrev: 'JM',
                name: 'Jamaica',
            }, {
                abbrev: 'JP',
                name: 'Japan',
                postal: [v => /[0-9]{3}-[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'JE',
                name: 'Jersey',
                postal: [v => /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'JO',
                name: 'Jordan',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'KZ',
                name: 'Kazakhstan',
                postal: [v => /[0-9]{6}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'KE',
                name: 'Kenya',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'KI',
                name: 'Kiribati',
            }, {
                abbrev: 'KR',
                name: 'Korea, Republic of',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'KP',
                name: 'Korea, The D.P.R of',
            }, {
                abbrev: 'XK',
                name: 'Kosovo',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'KW',
                name: 'Kuwait',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'KG',
                name: 'Kyrgyzstan',
                postal: [v => /[0-9]{6}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'LA',
                name: 'Laos',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'LV',
                name: 'Latvia',
                postal: [v => /LV-[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'LB',
                name: 'Lebanon',
                postal: [v => /[0-9]{4} [0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'LS',
                name: 'Lesotho',
                postal: [v => /[0-9]{3}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'LR',
                name: 'Liberia',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'LY',
                name: 'Libya',
            }, {
                abbrev: 'LI',
                name: 'Liechtenstein',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
                range: ['9485', '9498'],
            }, {
                abbrev: 'LT',
                name: 'Lithuania',
                postal: [v => /LT-[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'LU',
                name: 'Luxembourg',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'MO',
                name: 'Macau',
            }, {
                abbrev: 'MK',
                name: 'Macedonia, Republic of',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'MG',
                name: 'Madagascar',
                postal: [v => /[0-9]{3}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'MW',
                name: 'Malawi',
            }, {
                abbrev: 'MY',
                name: 'Malaysia',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'MV',
                name: 'Maldives',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'ML',
                name: 'Mali',
            }, {
                abbrev: 'MT',
                name: 'Malta',
                postal: [v => /[A-Z]{3} [0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'MH',
                name: 'Marshall Islands',
                postal: [v => /^\d{5}(?:[-\s]\d{4})?$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
                range: ['96960', '96970'],
            }, {
                abbrev: 'MQ',
                name: 'Martinique',
                postal: [v => /972[0-9]{2}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
                range: ['97200', '97290'],
            }, {
                abbrev: 'MR',
                name: 'Mauritania',
            }, {
                abbrev: 'MU',
                name: 'Mauritius',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'YT',
                name: 'Mayotte',
                postal: [v => /976[0-9]{2}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
                range: ['97600', '97690'],
            }, {
                abbrev: 'MX',
                name: 'Mexico',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'MD',
                name: 'Moldova, Republic of',
                postal: [v => /MD-?[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'MC',
                name: 'Monaco',
                postal: [v => /980[0-9]{2}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'MN',
                name: 'Mongolia',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'ME',
                name: 'Montenegro',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'MS',
                name: 'Montserrat',
                postal: [v => /MSR [0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
                range: ['MSR 1110', 'MSR 1350'],
            }, {
                abbrev: 'MA',
                name: 'Morocco',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'MZ',
                name: 'Mozambique',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'MM',
                name: 'Myanmar',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'NA',
                name: 'Namibia',
            }, {
                abbrev: 'NR',
                name: 'Nauru',
            }, {
                abbrev: 'NP',
                name: 'Nepal',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'NL',
                name: 'Netherlands',
                // https://rgxdb.com/r/4W9GV8AC
                postal: [v => /^(?:NL-)?(\d{4})\s*([A-Z]{2})$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'NC',
                name: 'New Caledonia',
                postal: [v => /988[0-9]{2}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
                range: ['96950', '96952'],
            }, {
                abbrev: 'NZ',
                name: 'New Zealand',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'NI',
                name: 'Nicaragua',
            }, {
                abbrev: 'NE',
                name: 'Niger',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'NG',
                name: 'Nigeria',
                postal: [v => /[0-9]{6}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'NU',
                name: 'Niue',
            }, {
                abbrev: 'MP',
                name: 'Northern Mariana Islands',
                postal: [v => /^\d{5}(?:[-\s]\d{4})?$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'NO',
                name: 'Norway',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'OM',
                name: 'Oman',
                postal: [v => /[0-9]{3}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'PK',
                name: 'Pakistan',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'PW',
                name: 'Palau',
                postal: [v => /^\d{5}(?:[-\s]\d{4})?$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'PA',
                name: 'Panama',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'PG',
                name: 'Papua New Guinea',
                postal: [v => /[0-9]{3}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'PY',
                name: 'Paraguay',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'PE',
                name: 'Peru',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'PH',
                name: 'Philippines',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'PL',
                name: 'Poland',
                postal: [v => /[0-9]{2}-[0-9]{3}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'PT',
                name: 'Portugal',
                postal: [v => /[0-9]{4}-[0-9]{3}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'PR',
                name: 'Puerto Rico',
                postal: [v => /^\d{5}(?:[-\s]\d{4})?$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'QA',
                name: 'Qatar',
            }, {
                abbrev: 'RE',
                name: 'Réunion',
                postal: [v => /974[0-9]{2}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
                range: ['97400', '97490'],
            }, {
                abbrev: 'RO',
                name: 'Romania',
                postal: [v => /[0-9]{6}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'RU',
                name: 'Russian Federation',
                postal: [v => /[0-9]{6}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'RW',
                name: 'Rwanda',
            }, {
                abbrev: 'MP',
                name: 'Saipan',
                postal: [v => /96950$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'WS',
                name: 'Samoa',
                postal: [v => /WS[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'ST',
                name: 'Sao Tome and Principe',
            }, {
                abbrev: 'SA',
                name: 'Saudi Arabia',
                postal: [v => /[0-9]{5}(-[0-9]{4})?$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'SN',
                name: 'Senegal',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'RS',
                name: 'Serbia',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'SC',
                name: 'Seychelles',
            }, {
                abbrev: 'SL',
                name: 'Sierra Leone',
            }, {
                abbrev: 'SG',
                name: 'Singapore',
                postal: [v => /[0-9]{6}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'SK',
                name: 'Slovakia',
                postal: [v => /[0-9]{3} [0-9]{2}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'SI',
                name: 'Slovenia',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'SB',
                name: 'Solomon Islands',
            }, {
                abbrev: 'SO',
                name: 'Somalia',
                postal: [v => /[A-Z]{2} [0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'ZA',
                name: 'South Africa',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'SS',
                name: 'South Sudan',
            }, {
                abbrev: 'ES',
                name: 'Spain',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'LK',
                name: 'Sri Lanka',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'BL',
                name: 'St. Barthélemy',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
                range: ['97100', '97190'],
            }, {
                abbrev: 'VI',
                name: 'St. Croix',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'SE',
                name: 'St. Eustatius',
            }, {
                abbrev: 'SH',
                name: 'St. Helena',
                postal: [v => /STHL 1ZZ$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'AG',
                name: 'St. John',
                postal: [v => /^\d{5}(?:[-\s]\d{4})?$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'KN',
                name: 'St. Kitts and Nevis',
                postal: [v => /[A-Z]{2}[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'LC',
                name: 'St. Lucia',
                postal: [v => /[A-Z]{2}[0-9]{2} [0-9]{3}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'SX',
                name: 'St. Maarten',
            }, {
                abbrev: 'VI',
                name: 'St. Thomas',
            }, {
                abbrev: 'VC',
                name: 'St. Vincent and the Grenadines',
                postal: [v => /VC[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'SD',
                name: 'Sudan',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'SR',
                name: 'Suriname',
            }, {
                abbrev: 'SZ',
                name: 'Swaziland',
                postal: [v => /[A-Z]{1}[0-9]{3}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'SE',
                name: 'Sweden',
                postal: [v => /[0-9]{3} [0-9]{2}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'CH',
                name: 'Switzerland',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'SY',
                name: 'Syria',
            }, {
                abbrev: 'PF',
                name: 'Tahiti',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'TW',
                name: 'Taiwan',
                postal: [v => /[0-9]{3}(-[0-9]{2})?$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'TZ',
                name: 'Tanzania',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'TH',
                name: 'Thailand',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'TG',
                name: 'Togo',
            }, {
                abbrev: 'TO',
                name: 'Tonga',
            }, {
                abbrev: 'VG',
                name: 'Tortola',
                postal: [v => /VG[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'TT',
                name: 'Trinidad and Tobago',
                postal: [v => /[0-9]{6}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'TN',
                name: 'Tunisia',
                postal: [v => /[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'TR',
                name: 'Turkey',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'TM',
                name: 'Turkmenistan',
                postal: [v => /[0-9]{6}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'TC',
                name: 'Turks and Caicos Islands',
                postal: [v => /TKCA 1ZZ$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'TV',
                name: 'Tuvalu',
            }, {
                abbrev: 'UG',
                name: 'Uganda',
            }, {
                abbrev: 'UA',
                name: 'Ukraine',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'AE',
                name: 'United Arab Emirates',
            }, {
                abbrev: 'GB',
                name: 'United Kingdom',
                postal: [v => /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'US',
                name: 'United States of America',
                postal: [v => /^\d{5}(?:[-\s]\d{4})?$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'UY',
                name: 'Uruguay',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'UZ',
                name: 'Uzbekistan',
                postal: [v => /[0-9]{6}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'VU',
                name: 'Vanuatu',
            }, {
                abbrev: 'VE',
                name: 'Venezuela',
                postal: [v => /[0-9]{4}(-[A-Z]{1})?$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'VN',
                name: 'Vietnam',
                postal: [v => /[0-9]{6}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'VG',
                name: 'Virgin Islands (British)',
                postal: [v => /VG[0-9]{4}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'VI',
                name: 'Virgin Islands (US)',
                range: ['00801', '00851'],
                postal: [v => /^\d{5}(?:[-\s]\d{4})?$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'YE',
                name: 'Yemen',
            }, {
                abbrev: 'ZM',
                name: 'Zambia',
                postal: [v => /[0-9]{5}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'],
            }, {
                abbrev: 'ZW',
                name: 'Zimbabwe',
            },
            ],

            nationalities: [{ NationalityID: 1, CountryCode: 'GB', Nationality: 'British' },
        { NationalityID: 34, CountryCode: 'AF', Nationality: 'Afghan' },
        { NationalityID: 35, CountryCode: 'AL', Nationality: 'Albanian' },
        { NationalityID: 36, CountryCode: 'DZ', Nationality: 'Algerian' },
        { NationalityID: 158, CountryCode: 'US', Nationality: 'American' },
        { NationalityID: 38, CountryCode: 'AD', Nationality: 'Andorran' },
        { NationalityID: 39, CountryCode: 'AO', Nationality: 'Angolan' },
        { NationalityID: 40, CountryCode: 'AM', Nationality: 'Armenian' },
        { NationalityID: 41, CountryCode: 'AT', Nationality: 'Austrian' },
        { NationalityID: 42, CountryCode: 'AZ', Nationality: 'Azerbaijani' },
        { NationalityID: 2, CountryCode: 'AR', Nationality: 'Argentinian' },
        { NationalityID: 3, CountryCode: 'AU', Nationality: 'Australian' },
        { NationalityID: 43, CountryCode: 'BH', Nationality: 'Bahraini' },
        { NationalityID: 44, CountryCode: 'BD', Nationality: 'Bangladeshi' },
        { NationalityID: 45, CountryCode: 'BB', Nationality: 'Barbadian' },
        { NationalityID: 46, CountryCode: 'BY', Nationality: 'Belarusian' },
        { NationalityID: 47, CountryCode: 'BZ', Nationality: 'Belizean' },
        { NationalityID: 48, CountryCode: 'BJ', Nationality: 'Beninese' },
        { NationalityID: 49, CountryCode: 'BM', Nationality: 'Bermudian' },
        { NationalityID: 50, CountryCode: 'BT', Nationality: 'Bhutanese' },
        { NationalityID: 51, CountryCode: 'BO', Nationality: 'Bolivian' },
        { NationalityID: 52, CountryCode: 'BA', Nationality: 'Bosnian' },
        { NationalityID: 53, CountryCode: 'BW', Nationality: 'Botswanan' },
        { NationalityID: 54, CountryCode: 'BG', Nationality: 'Bulgarian' },
        { NationalityID: 55, CountryCode: 'BF', Nationality: 'Burkinese' },
        { NationalityID: 56, CountryCode: 'BI', Nationality: 'Burundian' },
        { NationalityID: 7, CountryCode: 'CA', Nationality: 'Canadian' },
        { NationalityID: 8, CountryCode: 'CN', Nationality: 'Chinese' },
        { NationalityID: 9, CountryCode: 'CO', Nationality: 'Colombian' },
        { NationalityID: 10, CountryCode: 'CU', Nationality: 'Cuban' },
        { NationalityID: 57, CountryCode: 'KH', Nationality: 'Cambodian' },
        { NationalityID: 58, CountryCode: 'CM', Nationality: 'Cameroonian' },
        { NationalityID: 59, CountryCode: 'CV', Nationality: 'Cape Verdean' },
        { NationalityID: 60, CountryCode: 'TD', Nationality: 'Chadian' },
        { NationalityID: 61, CountryCode: 'CL', Nationality: 'Chilean' },
        { NationalityID: 62, CountryCode: 'CG', Nationality: 'Congolese' },
        { NationalityID: 63, CountryCode: 'CR', Nationality: 'Costa Rican' },
        { NationalityID: 64, CountryCode: 'HR', Nationality: 'Croat' },
        { NationalityID: 65, CountryCode: 'CY', Nationality: 'Cypriot' },
        { NationalityID: 66, CountryCode: 'CZ', Nationality: 'Czech' },
        { NationalityID: 67, CountryCode: 'DK', Nationality: 'Danish' },
        { NationalityID: 11, CountryCode: 'DO', Nationality: 'Dominican' },
        { NationalityID: 68, CountryCode: 'DJ', Nationality: 'Djiboutian' },
        { NationalityID: 69, CountryCode: 'DM', Nationality: 'Dominican' },
        { NationalityID: 26, CountryCode: 'NL', Nationality: 'Dutch' },
        { NationalityID: 12, CountryCode: 'EC', Nationality: 'Ecuadorean' },
        { NationalityID: 70, CountryCode: 'EG', Nationality: 'Egyptian' },
        { NationalityID: 71, CountryCode: 'ER', Nationality: 'Eritrean' },
        { NationalityID: 72, CountryCode: 'EE', Nationality: 'Estonian' },
        { NationalityID: 73, CountryCode: 'ET', Nationality: 'Ethiopian' },
        { NationalityID: 74, CountryCode: 'FJ', Nationality: 'Fijian' },
        { NationalityID: 75, CountryCode: 'FI', Nationality: 'Finnish' },
        { NationalityID: 76, CountryCode: 'PF', Nationality: 'French Polynesian' },
        { NationalityID: 14, CountryCode: 'FR', Nationality: 'French' },
        { NationalityID: 77, CountryCode: 'GA', Nationality: 'Gabonese' },
        { NationalityID: 78, CountryCode: 'GM', Nationality: 'Gambian' },
        { NationalityID: 79, CountryCode: 'GE', Nationality: 'Georgian' },
        { NationalityID: 15, CountryCode: 'DE', Nationality: 'German' },
        { NationalityID: 16, CountryCode: 'GT', Nationality: 'Guatemalan' },
        { NationalityID: 80, CountryCode: 'GH', Nationality: 'Ghanaian' },
        { NationalityID: 81, CountryCode: 'GR', Nationality: 'Greek' },
        { NationalityID: 82, CountryCode: 'GD', Nationality: 'Grenadian' },
        { NationalityID: 83, CountryCode: 'GN', Nationality: 'Guinean' },
        { NationalityID: 84, CountryCode: 'GY', Nationality: 'Guyanese' },
        { NationalityID: 17, CountryCode: 'HT', Nationality: 'Haitian' },
        { NationalityID: 18, CountryCode: 'HN', Nationality: 'Honduran' },
        { NationalityID: 85, CountryCode: 'HU', Nationality: 'Hungarian' },
        { NationalityID: 19, CountryCode: 'IN', Nationality: 'Indian' },
        { NationalityID: 20, CountryCode: 'IE', Nationality: 'Ireland' },
        { NationalityID: 21, CountryCode: 'IL', Nationality: 'Israeli' },
        { NationalityID: 22, CountryCode: 'IT', Nationality: 'Italian' },
        { NationalityID: 86, CountryCode: 'IS', Nationality: 'Icelandic' },
        { NationalityID: 87, CountryCode: 'ID', Nationality: 'Indonesian' },
        { NationalityID: 88, CountryCode: 'IR', Nationality: 'Iranian' },
        { NationalityID: 89, CountryCode: 'IQ', Nationality: 'Iraqi' },
        { NationalityID: 23, CountryCode: 'JP', Nationality: 'Japanese' },
        { NationalityID: 90, CountryCode: 'JM', Nationality: 'Jamaican' },
        { NationalityID: 91, CountryCode: 'JO', Nationality: 'Jordanian' },
        { NationalityID: 92, CountryCode: 'KZ', Nationality: 'Kazakh' },
        { NationalityID: 93, CountryCode: 'KE', Nationality: 'Kenyan' },
        { NationalityID: 94, CountryCode: 'KP', Nationality: 'North Korean' },
        { NationalityID: 95, CountryCode: 'KW', Nationality: 'Kuwaiti' },
        { NationalityID: 96, CountryCode: 'LV', Nationality: 'Latvian' },
        { NationalityID: 97, CountryCode: 'LB', Nationality: 'Lebanese' },
        { NationalityID: 98, CountryCode: 'LR', Nationality: 'Liberian' },
        { NationalityID: 99, CountryCode: 'LY', Nationality: 'Libyan' },
        { NationalityID: 100, CountryCode: 'LT', Nationality: 'Lithuanian' },
        { NationalityID: 101, CountryCode: 'LU', Nationality: 'LUXEMBOURG' },
        { NationalityID: 102, CountryCode: 'MG', Nationality: 'Madagascan' },
        { NationalityID: 103, CountryCode: 'MW', Nationality: 'Malawian' },
        { NationalityID: 104, CountryCode: 'MY', Nationality: 'Malaysian' },
        { NationalityID: 105, CountryCode: 'MV', Nationality: 'Maldivian' },
        { NationalityID: 106, CountryCode: 'ML', Nationality: 'Malian' },
        { NationalityID: 107, CountryCode: 'MT', Nationality: 'Maltese' },
        { NationalityID: 108, CountryCode: 'MR', Nationality: 'Mauritanian' },
        { NationalityID: 109, CountryCode: 'MU', Nationality: 'Mauritian' },
        { NationalityID: 110, CountryCode: 'MC', Nationality: 'Monacan' },
        { NationalityID: 111, CountryCode: 'MN', Nationality: 'Mongolian' },
        { NationalityID: 112, CountryCode: 'ME', Nationality: 'Montenegrin' },
        { NationalityID: 113, CountryCode: 'MA', Nationality: 'Moroccan' },
        { NationalityID: 114, CountryCode: 'MZ', Nationality: 'Mozambican' },
        { NationalityID: 25, CountryCode: 'MX', Nationality: 'Mexican' },
        { NationalityID: 115, CountryCode: 'NA', Nationality: 'Namibian' },
        { NationalityID: 116, CountryCode: 'NP', Nationality: 'Nepalese' },
        { NationalityID: 117, CountryCode: 'NZ', Nationality: 'New Zealand' },
        { NationalityID: 118, CountryCode: 'NI', Nationality: 'Nicaraguan' },
        { NationalityID: 119, CountryCode: 'NE', Nationality: 'Nigerien' },
        { NationalityID: 120, CountryCode: 'NG', Nationality: 'Nigerian' },
        { NationalityID: 121, CountryCode: 'NO', Nationality: 'Norwegian' },
        { NationalityID: 122, CountryCode: 'OM', Nationality: 'Omani' },
        { NationalityID: 123, CountryCode: 'PK', Nationality: 'Pakistani' },
        { NationalityID: 124, CountryCode: 'PA', Nationality: 'Panamanian' },
        { NationalityID: 125, CountryCode: 'PG', Nationality: 'Guinean' },
        { NationalityID: 126, CountryCode: 'PY', Nationality: 'Paraguayan' },
        { NationalityID: 127, CountryCode: 'PE', Nationality: 'Peruvian' },
        { NationalityID: 27, CountryCode: 'PH', Nationality: 'Philippine' },
        { NationalityID: 128, CountryCode: 'PL', Nationality: 'Polish' },
        { NationalityID: 129, CountryCode: 'PT', Nationality: 'Portuguese' },
        { NationalityID: 130, CountryCode: 'QA', Nationality: 'Qatari' },
        { NationalityID: 131, CountryCode: 'RO', Nationality: 'Romanian' },
        { NationalityID: 132, CountryCode: 'RW', Nationality: 'Rwandan' },
        { NationalityID: 13, CountryCode: 'SV', Nationality: 'Salvadorean' },
        { NationalityID: 37, CountryCode: 'AS', Nationality: 'Samoan' },
        { NationalityID: 133, CountryCode: 'SA', Nationality: 'Saudi Arabian' },
        { NationalityID: 134, CountryCode: 'SN', Nationality: 'Senegalese' },
        { NationalityID: 135, CountryCode: 'RS', Nationality: 'Serbian' },
        { NationalityID: 136, CountryCode: 'SL', Nationality: 'Sierra Leonian' },
        { NationalityID: 137, CountryCode: 'SG', Nationality: 'Singaporean' },
        { NationalityID: 138, CountryCode: 'SK', Nationality: 'Slovak' },
        { NationalityID: 139, CountryCode: 'SI', Nationality: 'Slovenian' },
        { NationalityID: 140, CountryCode: 'SB', Nationality: 'Slomoni' },
        { NationalityID: 141, CountryCode: 'SO', Nationality: 'Somali' },
        { NationalityID: 142, CountryCode: 'ZA', Nationality: 'South African' },
        { NationalityID: 24, CountryCode: 'KR', Nationality: 'South Korean' },
        { NationalityID: 28, CountryCode: 'ES', Nationality: 'Spanish' },
        { NationalityID: 29, CountryCode: 'SE', Nationality: 'Swedish' },
        { NationalityID: 30, CountryCode: 'CH', Nationality: 'Swiss' },
        { NationalityID: 143, CountryCode: 'LK', Nationality: 'Sri Lankan' },
        { NationalityID: 144, CountryCode: 'SD', Nationality: 'Sudanese' },
        { NationalityID: 145, CountryCode: 'SR', Nationality: 'Surinamese' },
        { NationalityID: 146, CountryCode: 'SZ', Nationality: 'Swazi' },
        { NationalityID: 31, CountryCode: 'TW', Nationality: 'Taiwanese' },
        { NationalityID: 147, CountryCode: 'TJ', Nationality: 'Tajik' },
        { NationalityID: 148, CountryCode: 'TH', Nationality: 'Thai' },
        { NationalityID: 149, CountryCode: 'TG', Nationality: 'Togolese' },
        { NationalityID: 150, CountryCode: 'TT', Nationality: 'Trinidadian' },
        { NationalityID: 151, CountryCode: 'TN', Nationality: 'Tunisian' },
        { NationalityID: 152, CountryCode: 'TR', Nationality: 'Turkish' },
        { NationalityID: 153, CountryCode: 'TM', Nationality: 'Turkoman' },
        { NationalityID: 154, CountryCode: 'TV', Nationality: 'Tuvaluan' },
        { NationalityID: 155, CountryCode: 'UG', Nationality: 'Ugandan' },
        { NationalityID: 156, CountryCode: 'UA', Nationality: 'Ukrainian' },
        { NationalityID: 157, CountryCode: 'AE', Nationality: 'Emirati' },
        { NationalityID: 32, CountryCode: 'VE', Nationality: 'Venezuelan' },
        { NationalityID: 33, CountryCode: 'VN', Nationality: 'Vietnamese' },
        { NationalityID: 159, CountryCode: 'UY', Nationality: 'Uruguayan' },
        { NationalityID: 160, CountryCode: 'UZ', Nationality: 'Uzbek' },
        { NationalityID: 161, CountryCode: 'VU', Nationality: 'Vanuatuan' },
        { NationalityID: 162, CountryCode: 'YE', Nationality: 'Yemeni' },
        { NationalityID: 163, CountryCode: 'ZM', Nationality: 'Zambian' }
        ],
        }
    },
    //Mixin lifecycle hooks are called on any component that includes them
    mounted() {

        // if (this.getAccount == null && !this.getIsLoadingAccount)
        //     this.fetchAccount(); // This will 401 if still not logged in causing re-direct via the axios intercepter
    },
    methods: {
    
    }
}